export const ALLOWED_TO_REFRESH_HEADER_NAME = 'Allowed-To-Refresh';
